export const STORAGE_OPTION_VALUES = [
  "lvb_storage",
  "fulfilment_efreight",
  "contains_batteries",
] as const;

export type StorageOption = (typeof STORAGE_OPTION_VALUES)[number];

export const STORAGE_OPTION_TRANSLATION_KEYS: Record<
  StorageOption,
  string
> = {
  lvb_storage: "bookingWizard.deliveryDetails.storageOptions.lvbStorage",
  fulfilment_efreight:
    "bookingWizard.deliveryDetails.storageOptions.fulfilmentEfreight",
  contains_batteries:
    "bookingWizard.deliveryDetails.storageOptions.containsBatteries",
};

export const STORAGE_OPTION_LABELS: Record<StorageOption, string> = {
  lvb_storage: "(Temporary) storage for LVB or external fulfilment center",
  fulfilment_efreight: "Fulfilment via E-Freight Forwarding",
  contains_batteries: "Product contains batteries",
};

export function isStorageOption(value: unknown): value is StorageOption {
  return (
    typeof value === "string" &&
    STORAGE_OPTION_VALUES.includes(value as StorageOption)
  );
}

export function isStorageBooking(record: {
  booking_delivery_info?: unknown;
}): boolean {
  const deliveryInfo = record.booking_delivery_info;
  if (!deliveryInfo) return true;
  if (Array.isArray(deliveryInfo) && deliveryInfo.length === 0) return true;
  return false;
}
